export const HeroSection = () => {
  return (
    <section
      className="light-section"
      style={{ marginTop: "4rem", marginBottom: "2rem" }}
      id="top"
    >
      <div className="columna">
        <span className="horizontal gap-8" style={{ marginBottom: 24 }}>
          <span className="linea-negra"></span>
          <p className="datos-upper-text">Impulsá tu negocio</p>
        </span>

        <p className="section-title">
          <span>
            <span style={{ color: "var(--red-highlight)" }}>Reservá hoy</span>
            <br />
            tu demo
            <br />
            personalizada
            <br />
          </span>
        </p>

        <p className="section-subtitle">
          ¿Querés conocer más a fondo cómo funciona?
          <br />
          Agendá una demo con nosotros y descubrí cómo
          <br />{" "}
          <span className="underscore">
            nuestros productos pueden ayudarte{" "}
            <img
              style={{}}
              src={`${process.env.PUBLIC_URL}/assets/imagenes/subrayado2-21.png`}
              alt="subrayado"
            />
          </span>
          a vender más y trabajar mejor.
        </p>
      </div>
      <img
        className="img-tableros"
        src={`${process.env.PUBLIC_URL}/assets/imagenes/demo/demo-main.png`}
        alt="tableros"
      />
    </section>
  );
};
